import { RouteCodes } from '@strata/constants';

/** LaunchDarkly flag: special-handling icon on referral/treatment member name. */
// eslint-disable-next-line no-secrets/no-secrets -- LaunchDarkly flag key
export const SPECIAL_MEMBER_HANDLING_FLAG = 'showSpecialMemberHandling';

export const MemberAttributes = {
    AMMO: 'AMMO',
    LTC: 'LTC',
    VIP_OOS: 'VIP_OOS',
};

export const SpecialHandlingScenario = {
    PREFERRED_PHARMACY: 'PREFERRED_PHARMACY',
    AMMO: 'AMMO',
    LTC: 'LTC',
    VIP_OOS: 'VIP_OOS',
};

const ATTRIBUTE_ORDER = [MemberAttributes.AMMO, MemberAttributes.LTC, MemberAttributes.VIP_OOS];

const ATTRIBUTE_HANDLING = {
    [MemberAttributes.AMMO]: {
        scenario: SpecialHandlingScenario.AMMO,
        tooltip: 'Patient out of scope: AMMO',
    },
    [MemberAttributes.LTC]: {
        scenario: SpecialHandlingScenario.LTC,
        tooltip: 'Patient out of scope: LTC',
    },
    [MemberAttributes.VIP_OOS]: {
        scenario: SpecialHandlingScenario.VIP_OOS,
        tooltip: 'Patient out of scope',
    },
};

/**
 * Collect all matching scenarios; tooltip is one string per match (rendered as lines).
 * Preferred pharmacy first (when present), then OOS attributes in AMMO → LTC → VIP_OOS order.
 * @param {{ attributes?: string[], isPreferredPharmacy?: boolean, preferredPharmacyName?: string }} input
 * @returns {{ scenario: string, scenarios: string[], tooltip: string[] } | null}
 */
export const resolveSpecialMemberHandling = ({
    attributes = [],
    isPreferredPharmacy = false,
    preferredPharmacyName = undefined,
} = {}) => {
    const matches = [];

    if (isPreferredPharmacy) {
        const pharmacyLabel = preferredPharmacyName?.trim() || 'preferred pharmacy';
        matches.push({
            scenario: SpecialHandlingScenario.PREFERRED_PHARMACY,
            tooltip: `Must use patient-preferred pharmacy: ${pharmacyLabel}`,
        });
    }

    const attributeSet = new Set((attributes ?? []).map((value) => String(value).toUpperCase()));
    ATTRIBUTE_ORDER.forEach((attribute) => {
        if (attributeSet.has(attribute)) {
            matches.push(ATTRIBUTE_HANDLING[attribute]);
        }
    });

    if (matches.length === 0) {
        return null;
    }

    return {
        scenario: matches[0].scenario,
        scenarios: matches.map((match) => match.scenario),
        tooltip: matches.map((match) => match.tooltip),
    };
};

/**
 * @param {string | undefined | null} routeCode
 * @returns {boolean}
 */
export const isPatientPreferredPharmacyRoute = (routeCode) =>
    routeCode === RouteCodes.MEMBER_PREFERENCE;
